import React from 'react';
import './styles/Maintenance.scss';

class Maintenance extends React.Component {
	render() {
		return (
			<div id="maintenance" className="container pt-5">
				<h1>Distribution List Manager is Disabled for Maintenance</h1>
				<h3 className="pt-4">We&#39;re undergoing a bit of maintenance.</h3>
				<p>Sorry for the inconvenience. We&#39;ll be back up and running as fast as possible.</p>
			</div>
		);
	}
}

export default Maintenance;